import {RecipeDetailedCardBody} from '@mfb/cookbook';
import {DetailedCardContext, DetailedCardContextProps, DetailedCardHeader, DetailedCardModal} from '@mfb/lego';
import * as React from 'react';

export interface RecipeDetailModalProps {
  model?: DetailedCardContextProps;
  isOpen: boolean;
  onClose: () => void;
}

const RecipeDetailModal: React.FunctionComponent<RecipeDetailModalProps> = ({model, isOpen, onClose}) => {
  if (!model) {
    return null;
  }

  return (
    <DetailedCardModal isOpen={isOpen} toggle={onClose} headerTitle="Meal Details">
      <DetailedCardContext.Provider value={model}>
        <DetailedCardHeader actionBar={undefined} />
        <RecipeDetailedCardBody />
      </DetailedCardContext.Provider>
    </DetailedCardModal>
  );
};

export default RecipeDetailModal;
